
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './tailwind.css';
import './styles/drag-drop.css';
import { ThemeProvider } from './components/ThemeContext';

// Global error surface for production debugging (prevents silent white screen).
// This should remain lightweight; we can remove/soften once stable.
const showFatal = (title: string, detail: any) => {
  try {
    // eslint-disable-next-line no-console
    console.error(title, detail);
    const root = document.getElementById('root');
    if (root && !root.innerHTML) {
      const pre = document.createElement('pre');
      pre.style.whiteSpace = 'pre-wrap';
      pre.style.padding = '16px';
      pre.style.fontSize = '12px';
      pre.style.color = '#0f172a';
      pre.textContent = `${title}\n\n${String(detail?.stack || detail?.message || detail)}`;
      root.appendChild(pre);
    }
  } catch {
    // ignore
  }
};

window.addEventListener('error', (e) => {
  // @ts-ignore
  showFatal('App crashed (error)', e?.error || e?.message);
});
window.addEventListener('unhandledrejection', (e) => {
  // @ts-ignore
  showFatal('App crashed (unhandled promise rejection)', e?.reason || e);
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
